import { render } from "./cat_products_component.vue?vue&type=template&id=2b2120ec&scoped=true"
import script from "./cat_products_component.vue?vue&type=script&lang=js"
export * from "./cat_products_component.vue?vue&type=script&lang=js"

import "./cat_products_component.vue?vue&type=style&index=0&id=2b2120ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2120ec"]])

export default __exports__